import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
const AttributesHome = () => import('./Index.vue');
import { CUSTOM_ATTRIBUTE_PERMISSIONS } from 'dashboard/constants/permissions.js';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'attributes_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'attributes_list',
          component: AttributesHome,
          meta: {
            featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
            permissions: ['administrator', CUSTOM_ATTRIBUTE_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
